import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import BooksOutlineButton from '../common/buttons/BooksOutlineButton';

import BooksStaffDescription from './BooksStaffDescription';
import css from './BooksStaffMenu.module.scss';

interface Props {
  className?: string;
  staffName: string;
  staffImage?: string;
  staffID?: number;
  description?: string;
  border?: string;
  postable: boolean;
  onClick?: (event: React.MouseEvent) => void;
}

const BooksStaffMenu = ({
  className,
  intl,
  staffName,
  staffImage,
  staffID,
  description,
  border,
  postable,
  onClick,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksStaffMenu, className, {
    [css.bdTop]: border === 'top',
    [css.bdBottom]: border === 'bottom',
    [css.bdBoth]: border === 'both',
  });
  return (
    <div className={classes} data-style={description ? 'wrap' : 'noWrap'}>
      {staffImage && (
        <img
          className={css.BooksStaffMenu__Img}
          alt={staffName}
          src={staffImage}
        />
      )}
      <div
        className={css.BooksStaffMenu__Texts}
        data-style={staffImage && 'hasImage'}
      >
        <p className={css.BooksStaffMenu__Name}>{staffName}</p>
        {description && <BooksStaffDescription text={description} />}
      </div>
      <div className={css.BooksStaffMenu__Button}>
        <BooksOutlineButton
          onClick={onClick}
          disabled={!postable}
          value={staffID}
        >
          <span className={postable ? undefined : css.BooksStaffMenu__Loading}>
            {intl.formatMessage({ id: 'books.button.select' })}
          </span>
        </BooksOutlineButton>
      </div>
    </div>
  );
};

export default injectIntl(BooksStaffMenu);
